import { useEffect, useState } from 'react';

export const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleResizeError = (e: any) => {
      if (e.message === 'ResizeObserver loop limit exceeded') {
        // console.error(e);
        e.stopImmediatePropagation();
      }
      if (
        e.message ===
        'ResizeObserver loop completed with undelivered notifications.'
      ) {
        // console.error(e);
        e.stopImmediatePropagation();
      }
    };
    window.addEventListener('error', handleResizeError);

    return () => window.removeEventListener('error', handleResizeError);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
};
